import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.NON_AUTHENTICATED_EXCHANGES_PATH,
	name: routeList.NON_AUTHENTICATED_EXCHANGES_NAME,
	component: () => import('@/views/Exchanges')
}, {
	path: routeList.EXCHANGES_PATH,
	name: routeList.EXCHANGES_NAME,
	component: () => import('@/views/Exchanges')
}]
